/**
 * Sync Center - English
 */
export const syncCenterEn = {
  sidebar: {
    title: 'Sync Center',
    entraId: 'Entra ID Sync',
    dingtalk: 'DingTalk Sync',
    dingtalkEmployees: 'Employees',
    dingtalkQuotas: 'Leave Balance Overview',
    dingtalkRelease: 'Annual Leave Release Plan',
    dingtalkSap: 'SAP Purchase Sync',
    adp: 'ADP PTO Sync',
    adpPto: 'PTO Schedule',
  },
  adp: {
    taskName: {
      ADP_LINKER: 'ADP Employee ID Binding',
      ADP_PTO_SYNC: 'ADP PTO Schedule Sync',
    },
    pageTitle: 'ADP PTO Sync',
    pageDescription:
      'Admin data validation tool. Shows only employees and PTO time ranges; no leave type or reason (CPRA compliance).',
    loading: 'Loading...',
    statusBadge: {
      success: 'Success',
      failed: 'Failed',
      running: 'Running',
      timeout: 'Timeout',
    },
    task: {
      lastRun: 'Last run',
      totals: 'Total / Success / Failed',
      lastDuration: 'Last duration',
      runNow: 'Run now',
      running: 'Running...',
      lastError: 'Last error',
      lastLogs: 'Last logs',
    },
    configMissing: 'ADP configuration missing:',
    filter: {
      startDate: 'Start date',
      endDate: 'End date',
      search: 'Search (name / email)',
      searchPlaceholder: 'Search by name or email',
      refresh: 'Refresh',
    },
    summary: '{total} total; page {page} / {totalPages}',
    table: {
      employee: 'Employee',
      email: 'Email',
      date: 'Date (PT)',
      timeRange: 'Time (PT)',
      syncedAt: 'Synced at',
      empty: 'No data',
    },
    pagination: {
      prev: 'Previous',
      next: 'Next',
    },
    unmatched: {
      title: 'Unmatched ADP employees',
      desc: 'Email mismatch or out-of-sync; you can search and bind to a FF AI user manually.',
      empty: 'No unmatched ADP employees',
      lastRunAt: 'From the last Linker run ({time})',
      colAdp: 'ADP employee',
      colMatch: 'Manually match FF AI user',
      searchPlaceholder: 'Search by name / email (≥ 2 chars)',
      bind: 'Bind',
      binding: 'Binding...',
      bindSuccess: 'Bound {email} → {aoid}',
      bindFail: 'Bind failed: {msg}',
      pickFirst: 'Please pick a FF AI user first',
      noResult: 'No matching FF AI user',
    },
    toast: {
      statusFailed: 'Failed to load sync status: {msg}',
      listFailed: 'Failed to load PTO list: {msg}',
      dateRangeError: 'Date range exceeds the allowed window (max -30d ~ +60d)',
      triggerAccepted: 'Started, status will refresh automatically…',
      triggerAlreadyRunning: 'Task is already running. Please wait for it to finish.',
      triggerLinkerFail: 'Failed to trigger Linker: {msg}',
      triggerPtoFail: 'Failed to trigger PTO sync: {msg}',
      runFinishedSuccess: '{taskName} finished successfully ✅',
      runFinishedFailed: '{taskName} failed ❌',
    },
  },
};
